import * as React from 'react';

export const header = {
  heading: 'Information Sharing '
};
export const richText1 = {
  id: 'InformationSharing',
  html:
    '                <p>We may share your information for our business purposes and as legally required \n'
    + '                 or permitted by law. Please see below for examples of circumstances in which we share information.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>With third parties who perform services on our behalf.</p>\n'
    + '                <ul>\n'
    + '                  <li>Service providers, such as our delivery service providers who ship and deliver your orders </li> \n'
    + '                  <li>Providers of security and payment services </li> \n'
    + '                  <li>Shipping and mailing vendors </li>\n'
    + '                  <li>Providers of digital analytics services </li>\n'
    + '                  <li>Third parties that help us communicate with you </li>\n'
    + '                  <li>Marketing and advertising companies that help us learn about our customers or deliver advertisements</li>\n'
    + '                  <li>We might also share information with the vendors and manufacturers of our products and services \n'
    + '                      to respond to your reviews and questions</li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>In association with financial products. </p>\n'
    + '                <ul> \n'
    + '                  <li>We work with third parties to offer financial products, such as The Home Depot credit \n'
    + '                      card and home improvement loans </li>\n'
    + '                  <li>We share information with these third parties so that they can provide you with \n'
    + '                      tailored information about products and services and special offers </li>\n'
    + '                  <li>These third parties also have their own privacy statements that set out the \n'
    + '                      manner in which they will collect, use and disclose personal information</li>\n'
    + '                  <li>We encourage you to review each third party’s privacy statement at the time \n'
    + '                      you submit your application for such financial products</li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>To provide extended warranty services. </p>\n'
    + '                <ul> \n'
    + '                  <li>If you purchase a The Home Depot Extended Warranty Service you will be required to \n'
    + '                      provide information such as your name and address to our warranty service providers </li> \n'
    + '                  <li>If you purchase products at The Home Depot we may share your ' +
    'information with the third party providers that offer extended warranty services for follow-up to offer such services at a future date</li>'
    + '                  <li>We limit by contract the ways they may use your information to provide The Home Depot Extended Warranty Services </li>\n'
    + '                  <li>We encourage you to review each service provider&apos;s privacy statement at the \n'
    + '                      time you submit your personal information for such services  </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                 <p> With any successor to all or part of our business. </p> \n'
    + '                <ul> \n'
    + '                  <li>In-store, parking lot, and facility cameras track store traffic and stock  </li> \n'
    + '                  <li>Mitigating credit losses </li>\n'
    + '                  <li>Confirming the identity of our customers who rent trucks or certain types of tools or equipment </li> \n'
    + '                  <li>Retrieving unreturned tools or other equipment </li>\n'
    + '                  <li>Processing and tracking returns </li>\n'
    + '                  <li>Detecting and preventing fraud and malicious activities on our digital offerings and in your accounts </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>For our marketing. </p>\n'
    + '                <ul> \n'
    + '                  <li>For example, if all or part of our business is sold or otherwise acquired, we may sell or disclose our customer \n'
    + '                      lists and other personal information we collect in preparation for or as part of that transaction </li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>If we think we have to in order to comply with the law.</p>\n'
    + '                <ul> \n'
    + '                  <li>For example, we will disclose information to respond to a court order or subpoena. We may also \n'
    + '                      disclose information if a government agency or investigatory body requests it </li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> With our business partners.</p>\n'
    + '                <ul> \n'
    + '                  <li>For example, we might share information with one of our Affiliates or a business partner who is \n'
    + '                      running a joint promotion with us or who provides a product or service in partnership with us</li> \n'
    + '                  <li>And we may share information with joint marketing partners </li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> With advertising and marketing partners.</p> \n'
    + '                <ul> \n'
    + '                  <li>To manage and deliver advertising, including by placing ads on the websites and applications you access </li> \n'
    + '                  <li>To measure the effectiveness of our advertising campaigns </li> \n'
    + '                  <li>To identify the ads you have already seen, so that you don’t have to see the same ads too many times </li> \n'
    + '                  <li>To better understand your preferences and interests</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> For security and fraud prevention.</p>\n'
    + '                <ul> \n'
    + '                  <li>We will disclose information to detect, prevent, and investigate fraud or unlawful activities </li> \n'
    + '                  <li>We may also disclose information to collect debts or recover unreturned rental items</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> At your direction.</p>\n'
    + '                <ul> \n'
    + '                  <li>For example, if you ask us to provide your information to a third-party to facilitate the delivery of \n'
    + '                      services or resolution of a dispute </li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>Below, please find information about our disclosures of personal information for our business purposes:</p>\n'
    + '                <p>Identifiers, Commercial Information, and Property Information</p>\n'
    + '                <ul> \n'
    + '                  <li> Disclosed to: Service providers; Product Manufacturers and Extended Warranty Providers; Joint Marketing \n'
    + '                       Partners; Financial Service Companies; Advisors and Consultants; Law Enforcement, Public and Government \n'
    + '                       Authorities, and Others; Affiliates and Subsidiaries; Advertising Partners and Marketing Companies; \n'
    + '                       and Successors to All or Part of Our Business.</li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>Internet Activity, Demographic Information, Location Information, Employment Information, and Inferences:</p>\n'
    + '                <p>Identifiers, Commercial Information, and Property Information</p>\n'
    + '                <ul> \n'
    + '                  <li> Disclosed to: Service providers; Joint Marketing Partners; Advisors and Consultants; Law Enforcement, \n'
    + '                       Public and Government Authorities, and Others; Affiliates and Subsidiaries;\n'
    + '                       Authorities, and Others; Affiliates and Subsidiaries; Advertising Partners and Marketing Companies; \n'
    + '                       Advertising Partners and Marketing Companies; and Successors to All or Part of Our Business.</li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> Payment Information </p>\n'
    + '                <p>Identifiers, Commercial Information, and Property Information</p>\n'
    + '                <ul> \n'
    + '                  <li> Disclosed to: Service Providers; Financial Service Companies; Advisors and Consultants; Law Enforcement, \n'
    + '                       Public and Government Authorities, and Others; Affiliates and Subsidiaries; \n'
    + '                       and Successors to All or Part of Our Business.</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>Video/Audio Recordings and Biometric Information</p>\n'
    + '                <p>Identifiers, Commercial Information, and Property Information</p>\n'
    + '                <ul> \n'
    + '                  <li> Disclosed to: Service Providers; Advisors and Consultants; Law Enforcement, Public and Government \n'
    + '                       Authorities, and Others; Affiliates and Subsidiaries; and Successors to All or\n'
    + '                       Part of Our Business.</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>We do not share your information with third parties in exchange for money. We do share certain personal \n'
    + '                   information in exchange for insights and other valuable services. California law treats such sharing as a \n'
    + '                   “sale” even if no money is exchanged. </p>\n'
    + '                <ul> \n'
    + '                  <li> Identifiers, Internet Activity, Commercial Information, Demographic Information, Location Information, and Inferences: </li> \n'
    + '                  <li> Disclosed to: Advertising Partners and Marketing Companies. </li> \n'
    + '                 </ul>\n'

};
